// @flow
import { useState, useEffect } from 'react';
import AuthService from '@user/services/AuthService';
import type { User } from '@user/types/User';

type AuthState = {
  user: User | null,
  isConnected: boolean,
};

type UseAuth = {
  ...AuthState,
  isLoading: boolean,
  disconnect: (redirect?: boolean) => void,
};

const useAuth = (): UseAuth => {
  const [auth, setAuth] = useState<AuthState>({
    user: AuthService.user,
    isConnected: AuthService.isConnected,
  });

  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const unsubscribe = AuthService.onChange(setAuth);
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const checkInitialSession = async () => {
      try {
        await AuthService.autoLogin();
      } catch (error) {
        console.error('Auto-login check failed:', error);
      } finally {
        setIsLoading(false);
      }
    };

    checkInitialSession();
  }, []);

  return {
    user: auth.user,
    isConnected: auth.isConnected,
    isLoading,
    disconnect: AuthService.disconnect,
  };
};

export default useAuth;
